import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'
import { initTheme } from './theme'
import { i18n } from './i18n'

initTheme()

const app = createApp(App)

app.use(router)
app.use(i18n)

app.mount('#app')
